import path from 'ramda/src/path'

import moduleDescriptions from 'root/src/shared/descriptions/modules'
import moduleIdFromKey from 'root/src/client/logic/route/util/moduleIdFromKey'

export default (state, props) => {
	const { moduleKey, fieldDescPath } = props
	const fieldData = path([moduleIdFromKey(moduleKey), ...fieldDescPath], moduleDescriptions)
	if (!fieldData) {
		return []
	}
	if (typeof fieldData === 'function') {
		const field = fieldData(state, props)
		const { options } = field
		return options || []
	}
	const { options } = fieldData
	return options || []
}
